import { Injectable } from '@angular/core';
import {UserService} from "../user/user.service";
import {CmdbDataService} from "../cmdb-data/cmdb-data.service";


/**
 * This service provides access to other services when used via constructor injection
 * in a dynamic cmdb component such as an infobox.
 */
@Injectable({
  providedIn: 'root'
})
export class CmdbService {

  constructor(public userService: UserService, public cmdbDataService: CmdbDataService) { }
}
